export default "__VITE_ASSET__DJ7P7ZGE__"